// Maps a plan `code` to its analytics plan-type value (mirrors Android
// PlanType.analyticsValue). Canonical: vgn | lmp | taiChi | tns | kds | hpm |
// kdsBody.
export function planTypeFromCode(code: string): string {
  if (code.includes('vagus')) return 'vgn'
  if (code.includes('taiChi')) return 'taiChi'
  if (code.includes('lymphatic')) return 'lmp'
  if (code.includes('tension')) return 'tns'
  if (code.includes('neuroKids')) return 'kds'
  if (code.includes('hypermobility')) return 'hpm'
  if (code.includes('posture')) return 'posture'
  // Must stay below hypermobility: 'hypermobility'.includes('mobility') is true.
  if (code.includes('mobility')) return 'mobility'
  if (code.includes('heightmax')) return 'heightmax'
  if (code.includes('kdsBody')) return 'kdsBody'
  return code
}
